import React, { useEffect } from 'react';
import { LengthInput, Tooltip } from 'components/common';

const LengthFormField = ({ config, value, setValue, unit, register, errors, disabled, setFetchInProgress, readOnlyValues, context }) => {
  useEffect(() => {
    const timeoutIds = [];
    if (readOnlyValues != undefined) {
      readOnlyValues.forEach((readOnlyValue) => {
        if (readOnlyValue.name == config.name && readOnlyValue.value_eval != undefined) {
          const id = setTimeout(() => {
            let value_eval_result = eval(readOnlyValue.value_eval);
            if (value_eval_result != '' && value_eval_result != undefined) {
              setValue(config.name, (_prev) => { return value_eval_result });
            }
          }, 250);
          timeoutIds.push(id);
        }
      })
    }
    return () => { timeoutIds.forEach((id) => clearTimeout(id)); };
  }, [])

  return (
    <tr>
      <td>
        {t(config.label)} { config.tooltip_text != undefined && <Tooltip title={t(config.tooltip_text)} /> }
        {config.helper_text != undefined && (
          <><br /><small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: t(config.helper_text) }} /></>
        )}
      </td>
      <td align="right">
        <LengthInput
          name={config.name}
          register={register}
          errors={errors}
          unit={config.length_unit_in_values_need_translate ? t('quote_builder.' + unit) : unit}
          precision={config.precision}
          value={value}
          class_name={config.class_name}
          validators={config.validators != undefined ? config.validators : []}
          placeholder={config.placeholder}
          onChange={(e) => setValue(config.name, e.target.value)}
        />
      </td>
    </tr>
  )
}

export default LengthFormField;
